module.exports = __webpack_public_path__ + "static/fonts/Alibaba-PuHuiTi-Medium.95620e1.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Alibaba-PuHuiTi-Medium.otf
// module id = VpI/
// module chunks = 1